import { k } from "../kaplay";

import { attack } from "../components/attack";
import { properties } from "../data/properties";

export function addFireball({ angle }){
  const direction = k.Vec2.fromAngle(angle);
  const newFireball = k.add([
    "fireball",
    "attack_enemy",

    k.sprite("fire"),
    k.pos(k.center()),
    k.anchor("top"),
    k.area(),
    k.layer("game"),
    k.scale(properties.fireball.scale),
    k.rotate(angle - 90), 
    k.offscreen({ destroy: true }),
    k.move(direction, properties.fireball.speed),
    attack({ damage: properties.fireball.damage, attackFunc: async () => {
      newFireball.destroy(); 
    } }),
  ])

  k.play("shoot", { volume: 0.6 });

  return newFireball;
}